module.exports = __webpack_public_path__ + "img/Q2.da721fea.jpg";